import { Nav } from "react-bootstrap";

const ServicesTabs = ({ activeTab, setActiveTab }) => {
  return (
    <Nav className="flex-column" activeKey={activeTab} onSelect={(selectedKey) => setActiveTab(selectedKey)}>
      <Nav.Item>
        <Nav.Link eventKey="services">Our Services</Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link eventKey="industries">Industries</Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link eventKey="consultancy">Consultancy</Nav.Link>
      </Nav.Item>
    </Nav>
  );
};

export default ServicesTabs;
